import React, { useState } from 'react';
import { Button, Row, Col, Select } from 'antd';
import { LabelSetting } from '../types/label';
const { Option } = Select;

type Props = {
  labels: LabelSetting[];
  onSubmit: (label: undefined | string) => any;
  keyPress: any;
};
export const NewLabelPopup = (props: Props) => {
  const { labels, onSubmit, keyPress } = props;

  const [selectedLabel, setSelectedLabel] = useState<undefined | string>(undefined);

  return (
    <div>
      <Row gutter={16}>
        <Col span={24}>
          <Select
            showSearch
            value={selectedLabel}
            style={{ width: 200 }}
            onChange={(value: string) => setSelectedLabel(value)}
            onFocus={() => {
              window.removeEventListener('keydown', keyPress);
            }}
            onBlur={() => {
              window.addEventListener('keydown', keyPress);
            }}>
            {labels.map(label => (
              <Option key={label.name} value={label.name}>
                {label.name}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row gutter={16} style={{ marginTop: 10 }}>
        <Col span={24}>
          <Button type="primary" disabled={!selectedLabel} onClick={() => onSubmit(selectedLabel)}>
            Confirm
          </Button>
        </Col>
      </Row>
    </div>
  );
};
